import Joi from '@hapi/joi'

export const mobileMenuSchemaObject = {
    menuCode: Joi.string().required().invalid("00").min(2).max(2).label("Menu Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Menu Code required`,
        "string.pattern.base": `Menu Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as menu code`
    }),
    menuName: Joi.string().required().label("Menu Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Menu Name required`,
        "string.pattern.base": `Please enter valid Menu Name`,
    }),
    isActive: Joi.boolean().label("Active")
}